import React, { useState, useEffect, forwardRef } from "react";
import { Container, Grid } from "@material-ui/core";
import MaterialTable from "material-table";
import axios from "axios";
import {
	ViewColumn,
	AddBox,
	Search,
	SaveAlt,
	Remove,
	LastPage,
	FirstPage,
	FilterList,
	Clear,
	ChevronRight,
	ChevronLeft,
	Check,
	DeleteOutline,
	Edit,
	ArrowUpward,
} from "@material-ui/icons";

const api = axios.create({
	baseURL: `https://api-jrt.joshtalks.com`,
});

const tableIcons = {
	Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
	Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
	Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
	Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
	DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
	Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
	Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
	Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
	FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
	LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
	NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
	PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
	ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
	Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
	SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
	ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
	ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

function RegisteredUsers() {
	var columns = [
		{ title: "id", field: "id", hidden: true },
		{ title: "Name", field: "name" },
		{ title: "Email", field: "email" },
		{ title: "Phone", field: "mobileNumber" },
		{ title: "Age", field: "age" },
		{ title: "Current City", field: "city" },
		{ title: "Preferred Location", field: "location" },
		{ title: "Marital Status", field: "marital_status" },
	];
	const [data, setData] = useState([]); //table data

	useEffect(() => {
		api.get("/razorpay")
			.then((res) => {
				setData(res.data.unique);
			})
			.catch((error) => {
				// console.log("Error");
			});
	}, []);

	return (
		<div className="RegisteredUsers">
			<Container style={{ marginTop: "40px", marginBottom: "40px" }}>
				<Grid container spacing={1}>
					<Grid item xs={12}>
						<MaterialTable
							title="Form Responses"
							columns={columns}
							data={data}
							icons={tableIcons}
						/>
					</Grid>
				</Grid>
			</Container>
		</div>
	);
}

export default RegisteredUsers;
